import ReactPlayer from "react-player";
import LoadingVideo from "../../assets/loading.mp4";
import React, {memo} from "react";

const LoadingPlayer = () => (<div>
    <ReactPlayer muted={true}
                 loop={true}
                 playing={true}
                 controls={false}
                 url={LoadingVideo}
                 width={'100%'}
                 height={'100%'}/>
</div>)

export default memo(LoadingPlayer)